import { render, staticRenderFns } from "./class_list.vue?vue&type=template&id=3c6223c5&scoped=true&"
import script from "./class_list.vue?vue&type=script&lang=js&"
export * from "./class_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6223c5",
  null
  
)

export default component.exports